import { render, staticRenderFns } from "./BatchForm.vue?vue&type=template&id=1dd40547&"
import script from "./BatchForm.vue?vue&type=script&lang=js&"
export * from "./BatchForm.vue?vue&type=script&lang=js&"
import style0 from "./BatchForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd40547')) {
      api.createRecord('1dd40547', component.options)
    } else {
      api.reload('1dd40547', component.options)
    }
    module.hot.accept("./BatchForm.vue?vue&type=template&id=1dd40547&", function () {
      api.rerender('1dd40547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/BatchForm.vue"
export default component.exports